import { render, staticRenderFns } from "./VenuesTable.vue?vue&type=template&id=ff3f53da&"
import script from "./VenuesTable.vue?vue&type=script&lang=js&"
export * from "./VenuesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports